// libs
import React, { useMemo } from 'react'
import { IFeedProps } from 'src/components/feed/layouts/masonry_feed/masonry_feed'

// classes
import BannerFeedPlaceholder
  from 'src/components/content_placeholder/layouts/banner_feed_placeholder/banner_feed_placeholder'
import EmptyFeed from 'src/components/feed/empty_feed/empty_feed'
import EventBannerGroup from 'src/components/post/banner/event_banner_group'
import { CategoryFragment, EventFragment } from '@lopo-tech/lopo-api'

export type EventBannerGroup = {
  category: Pick<CategoryFragment, 'slug' | 'name'>
  events: EventFragment[]
}

type IProps = {
  groups: EventBannerGroup[];
  renderFeedTitle?: () => JSX.Element;
  showAllTopLink?: boolean;
  showGroupLabels?: boolean;
  onVisibleChange?: (id: string, inView: boolean) => void
} & Omit<IFeedProps, 'items'>;

const BannerFeed: React.FC<IProps> = ({
  groups,
  isLoading,
  renderPostCreate,
  renderFeedTitle,
  showAllTopLink,
  showEmptyFeed = true,
  showGroupLabels,
  onVisibleChange
}) => {
  const renderBannerFeed = useMemo(() => (
    <>
      {groups.map(({ category, events }, index) => (
        <EventBannerGroup
          key={index}
          eventGroup={events}
          onVisibleChange={onVisibleChange}
          title={showGroupLabels ? category.name : undefined}
          slug={category.slug}
          showAllTopLink={showAllTopLink}
        />
      ))}
    </>
  ), [groups, showAllTopLink, showGroupLabels])

  const renderEmptyFeed = () => {
    if (isLoading) {
      return <BannerFeedPlaceholder />
    }

    if (!showEmptyFeed) {
      return null
    }

    return <EmptyFeed />
  }

  const isEmpty = !groups.length

  return (
    <section>
      {renderPostCreate && renderPostCreate()}
      {renderFeedTitle && renderFeedTitle()}
      {isEmpty
        ? renderEmptyFeed()
        : renderBannerFeed
      }
    </section>
  )
}

export default BannerFeed
